<button
  mat-dialog-close
  mat-raised-button
  style="position: fixed; top: 12px; right: 12px"
>
  Close
</button>
<div mat-dialog-content style="max-height: 100vh">
  <ng-container *ngIf="data.marketingItemTypeId == 1">
    <img [src]="data.fileUrl" />
  </ng-container>
  <ng-container *ngIf="data.marketingItemTypeId == 5">
    <pdf-viewer
      [src]="data.fileUrl"
      [render-text]="true"
      [original-size]="false"
      style="width: 100%; display: block; height: 90vh"
    ></pdf-viewer>
  </ng-container>
  <ng-container *ngIf="data.marketingItemTypeId == 9">
    <video width="400" controls>
      <source [src]="data.fileUrl" type="video/mp4" />
      Your browser does not support HTML video.
    </video>
  </ng-container>
</div>
